"use client";

import { useCallback, useSyncExternalStore } from "react";

// Server snapshot — assume no match to avoid hydration mismatch.
function getServerSnapshot(): boolean {
  return false;
}

/** True while the given media query matches, re-rendering when that changes. */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (callback: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener("change", callback);
      return () => mql.removeEventListener("change", callback);
    },
    [query],
  );

  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
